import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './LinkToClaim.styles';
import { selectSelectedDrawersCount } from '../../redux/store/ui/common';
import { ExportOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { fetchClaimById } from '../../redux/store/userData/claims';

interface Props {
  label?: string;
  claimId: string;
}

const LinkToClaim: React.FC<Props> = ({ label, claimId }) => {
  const dispatch = useDispatch();
  const openedDrawersCount = useSelector(selectSelectedDrawersCount);

  const onClickHandler = (e: any) => {
    e.preventDefault();
    if (claimId != null && openedDrawersCount < 2) {
      dispatch(fetchClaimById(claimId));
    }
  };

  return (
    <>
      {openedDrawersCount < 2 ? (
        <span className="link" onClick={onClickHandler}>
          {label || ''}
        </span>
      ) : (
        <Link
          replace={false}
          to={{
            pathname: '/dashboard',
            search: `?vm=CLAIM&type=TABLE&pageSize=50&pageNumber=1&claimId=${claimId}`,
          }}
          target="_blank"
        >
          <a className="external-link-wrapper" target="_blank" rel="noreferrer">
            <span className="link">{label || ''}</span>
            <ExportOutlined
              color="#0077be"
              style={{ fontSize: '18px', marginLeft: '10px' }}
            />
          </a>
        </Link>
      )}
      <style jsx>{styles}</style>
    </>
  );
};

export default LinkToClaim;
